import getApiClient from '@/plugins/api'

export default {
    changePage: function(page) {
        this.page = page
    },

    checkAccess: function() {
        const requestRole = 'ROLE_AGENCY',
            self = this

        let userRole = ''

        if (self.$store.state.user.roles) {
            userRole = self.$store.state.user.roles[0]
        }

        if (userRole !== requestRole) {
            // self.$router.push('/')
        }
    },

    loadCarts: function() {
        const self = this,
            api = getApiClient(self.$root.$store)

        self.$store.commit('startLoading')

        Object.keys(self.search).forEach((item) => self.search[item] = null);

        self.search['page'] = self.page
        self.search['itemsPerPage'] = self.perPage

        if (self.searchParams.futureTrips) {
            self.search['trip.startTime[after]'] = new Date()
        }

        if (self.searchParams.pastTrips) {
            self.search['trip.startTime[before]'] = new Date()
        }

        if (self.searchParams.requestNumber) {
            self.search['id'] = self.searchParams.requestNumber
        }

        if (self.searchParams.agencyName) {
            self.search['trip.agency.name'] = self.searchParams.agencyName
        }

        if (self.searchParams.phone) {
            self.search['user.phone'] = self.searchParams.phone.replace(/[^\d]/g, '')
        }

        if (self.searchParams.name) {
            self.search['user.name'] = self.searchParams.name
        }

        if (self.searchParams.status) {
            self.search['status'] = self.searchParams.status
        }

        if (self.searchParams.since) {
            self.search['timestamp[after]'] = self.searchParams.since
        }

        self.search['exists[orders]'] = false

        api.get('abandoned_carts', {
            params: self.search
        })
            .then((result) => {
                self.carts = result.data['hydra:member']
                self.totalPages = Math.ceil(result.data['hydra:totalItems'] / self.perPage)
            })
            .catch((error) => {
                console.log(error)
            })
            .finally(() => {
                self.$store.commit('stopLoading')
            })
    },
}
